/*
 * Splideを上書きするためのCSS
 */

.splide {
  transition: opacity 0.3s ease-in-out;
  opacity: 0;
}

.splide.is-initialized {
  opacity: 1;
}

.splide__pagination {
  position: static;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 0;
}

#artWorkSlide .splide__pagination {
  margin-top: 40px;
}

.splide__pagination__page {
  margin: 0;
  background-color: #808080;
  border-radius: 50%;
  width: 6px;
  height: 6px;
}

.splide__pagination__page.is-active {
  background-color: var(--color-contrast);
  transform: scale(1);
  opacity: 1;
}

.splide__arrow {
  pointer-events: auto;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: var(--color-white);
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--color-contrast);
  opacity: 1;
}
.splide__arrow--prev {
  left: 40px;
}
.splide__arrow--prev svg {
  translate: -1px 0;
}
.splide__arrow--next {
  right: 40px;
}
.splide__arrow--next svg {
  translate: 1px 0;
}

.sub-splide .splide__arrows {
  pointer-events: none;
}

@media (max-width: 767px) {
  .splide__arrow {
    width: 30px;
    height: 30px;
  }
  .splide__arrow svg {
    width: 10px;
    height: 10px;
  }
  .splide__arrow--prev {
    left: 10px;
  }
  .splide__arrow--next {
    right: 10px;
  }
  .splide__pagination {
    gap: 6px;
  }
  #artWorkSlide .splide__pagination {
    margin-top: 20px;
  }
}


#modal-slide .splide__arrow {
  background-color: transparent;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 20px;
  top: auto;
  transform: translateY(0);
  transition: opacity 0.1s;
}
#modal-slide .splide__arrow svg {
  width: 16px;
  height: 30px;
}
#modal-slide .splide__arrow--prev svg {
  transform: rotate(0);
}
#modal-slide .splide__arrow--prev {
  left: calc(50% - 80px);
  translate: -100% 0;
}
#modal-slide .splide__arrow--next {
  right: calc(50% - 80px);
  translate: 100% 0;
}
#modal-slide .splide__arrow:hover {
  opacity: 0.3;
}